import { Button, Paper, Stack, Typography } from '@mui/material'
import { IKpiResponse } from '../../../definitions/DataAnalytics'
import { QueryStatus } from '../../hooks/useQuery'
import SmartCard from '../cards/SmartCard'
import KPICard from './KPICardUpdated'

export const KpiCardsResult = ({ data, status, refetch }: { data: IKpiResponse, status: QueryStatus, refetch?: () => void }) => {
    const kpiSkeletons = idx => (
        <SmartCard key={idx} flex={1}>
            <KPICard
                label=''
                data={{
                    value: 0,
                    df: {
                        delta: 0,
                        deltaPercentage: 0,
                        points: []
                    }
                }}
                chipLabel='MoM'
                isLoading={true}
            />
        </SmartCard>
    )

    switch (status) {
        case 'success':
            return Object.values(data).map((element, j) => (
                <SmartCard flex={1} key={`kpi-${j}`}>
                    <KPICard
                        data={element.data}
                        label={element.label}
                        unit={element.unit}
                        chipLabel='MoM'
                    />
                </SmartCard>
            ))

        case 'loading':
            return (
                <>{Array.from({ length: 4 }).map((_, i) => kpiSkeletons(i))}</>
            )
        case 'error':
            return (
                <Paper sx={{ width: '100%', height: '100%', p: 2 }}>
                    <Stack spacing={1} sx={{ justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                        <Typography>
                            There was an error during the data fetching
                        </Typography>
                        <Button variant='contained' color='error' onClick={() => refetch?.()}>
                            Retry
                        </Button>
                    </Stack>
                </Paper>
            )
    }
}
